// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"f6196195","253":"c5901fea","465":"b5c3a470","532":"cd658990","589":"a53ec6d8","640":"94ac059f","641":"74016b21","740":"d0f1651a","744":"3e26b00a","912":"2b50c130"}[chunkId] + ".chunk.js";
};